import { LOCALES } from '../constants';

const en = {
	[LOCALES.en]: {
		Russian: 'Русский',
		English: 'English',
		Ukrainian: 'Українська',
		Authorization: 'Authorization',
		Registration: 'Registration',
		'Your account has been blocked': 'Your account has been blocked',
		'Please contact support for assistance': 'Please contact support for assistance',
		'Contact support': 'Contact support',
		'Yes, change': 'Yes, change',
		No: 'No',
		'Re-enter hash': 'Re-enter hash',
		'Are you sure you have to re-enter the hash?': 'Are you sure you have to re-enter the hash?',
		'Your request is being processed': 'Your request is being processed',
		'Your unblock request has been sent to support': 'Your unblock request has been sent to support',
		Back: 'Back',
		'First login attempt is failed': 'First login attempt is failed',
		'Oops! Something went wrong. Please try again.': 'Oops! Something went wrong. Please try again.',
		'An error occurred': 'An error occurred',
		Refresh: 'Refresh',
		'QR code reading error': 'QR code reading error',
		'Try again': 'Try again',
		'Authorization failed': 'Authorization failed',
		'First login': 'First login',
		'Enter your login': 'Enter your login',
		'I agree to the': 'I agree to the',
		'Terms of Use and the Public Offer Agreement': 'Terms of Use and the Public Offer Agreement',
		Continue: 'Continue',
		'Create new password': 'Create new password',
		'Enter your password': 'Enter your password',
		'Repeat your password': 'Repeat your password',
		'The password must contain 6 - 64 characters, including lowercase and uppercase Latin letters and at least one number.':
			'The password must contain 6 - 64 characters, including lowercase and uppercase Latin letters and at least one number.',
		'Hash or QR is invalid': 'Hash or QR is invalid',
		'I Agree': 'I Agree',
		'Incorrect login': 'Incorrect login',
		'Exceeded the number of registration attempts! Login blocked for {min} min {sec} sec':
			'Exceeded the number of registration attempts!\nLogin blocked for {min} min {sec} sec',
		'Welcome to {br} {billingName} Wallet': 'Welcome to {br} {billingName} Wallet',
		'Your personal crypto wallet for everyday payments and work with cryptocurrency.':
			'Your personal crypto wallet for everyday payments and work with cryptocurrency.',
		'Sign up': 'Sign up',
		'Sign in': 'Sign in',
		'Passwords are different': 'Passwords are different',
		'Enter hash or scan QR code': 'Enter hash or scan QR code',
		Login: 'Login',
		'Enter your login and password': 'Enter your login and password',
		'Login or password is incorrect': 'Login or password is incorrect',
		'Exceeded the number of authorization attempts! Login blocked fo {m} min {s} sec':
			'Exceeded the number of authorization attempts!\nLogin blocked fo {m} min {s} sec',
		Paste: 'Paste',
		"Password doesn't match": "Password doesn't match",
		'Crypto portfolio': 'Crypto portfolio',
		Send: 'Send',
		Receive: 'Receive',
		Sent: 'Sent',
		Received: 'Received',
		Assets: 'Assets',
		History: 'History',
		Address: 'Address',
		Addresses: 'Addresses',
		'All addresses': 'All addresses',
		Account: 'Account',
		Hash: 'Hash',
		Password: 'Password',
		Success: 'Success',
		'Your password': 'Your password',

		'Select network': 'Select network',

		'Scan the QR code': 'Scan the QR code',
		'Point your camera at the QR code with the address.': 'Point your camera at the QR code with the address.',
		'Upload QR code': 'Upload QR code',
		'Select asset': 'Select asset',
		'Select address': 'Select address',
		'Enter payment details': 'Enter payment details',
		'Confirm payment': 'Confirm payment',
		'This address does not belong to the blockchain {currency}':
			'This address does not belong to the blockchain {currency}',
		'The minimum withdrawal amount is {amount} {currency}': 'The minimum withdrawal amount is {amount} {currency}',
		'The amount exceeds the balance on the address': 'The amount exceeds the balance on the address',
		Send_v2: 'Send',
		Send_v3: 'Send',
		Step: 'Step {number}',
		'Enter payment information': 'Enter payment information',
		'Recipient address': 'Recipient address',
		'Type recipient address': 'Type recipient address',
		'Transaction fee': 'Transaction fee',
		'Learn about transaction fees': 'Learn about transaction fees',
		'This is the fee paid to the blockchain to process your transaction. Transaction speed depends on the fee amount: higher fees are usually confirmed faster':
			'This is the fee paid to the blockchain to process your transaction. Transaction speed depends on the fee amount: higher fees are usually confirmed faster.',
		'Use a single transaction for inputs': 'Use a single transaction for inputs',
		'All inputs will be combined into one transaction. This can lower the total fee but increases the chance that those addresses will be linked on the blockchain.':
			'All inputs will be combined into one transaction. This can lower the total fee but increases the chance that those addresses will be linked on the blockchain.',
		'Note: combining inputs within a single transaction may result in visible linkage between addresses at the blockchain level. Consider this when choosing how inputs are processed.':
			'Note: combining inputs within a single transaction may result in visible linkage between addresses at the blockchain level. Consider this when choosing how inputs are processed.',
		'Got it': 'Got it',
		Amount: 'Amount',
		Cancel: 'Cancel',
		Available: 'Available',
		'Send max': 'Send max',
		'Fee amount': 'Fee amount',
		Fee: 'Fee',
		Comment: 'Comment',
		Success_v2: 'Success',
		Comments: 'Comments',
		'Transaction details': 'Transaction details',
		'View on block explorer': 'View on block explorer',
		'only you can see': 'only you can see',
		Optional: 'Optional',
		Amount_v2: 'Amount',
		'To be withdraw': 'To be withdraw',
		'To be receive by recipient': 'To be receive by recipient',
		'Sender address': 'Sender address',
		'Fee details': 'Fee details',
		'Fee from': 'Fee from',
		'Fee amount_v2': 'Fee amount',
		Confirm: 'Confirm',
		Details: 'Details',
		None: 'None',
		Queued: 'Queued',
		Completed: 'Completed',
		Failed: 'Failed',
		Processing: 'Processing',
		'Waiting confirmation': 'Waiting confirmation',
		Cancelled: 'Cancelled',
		'To be withdraw_v2': 'To be withdraw',
		'To be receive by recipient_v2': 'To be receive by recipient',
		Date: 'Date',
		Status: 'Status',
		Copy: 'Copy',
		Share: 'Share',
		Information: 'Information',
		'View on Tronscan': 'View on Tronscan',
		'View on Etherscan': 'View on Etherscan',
		'Send only {currency} to this address on the {network} network, otherwise you may lose your funds.':
			'Send only {currency} to this address on the {network} network, otherwise you may lose your funds.',
		'Share your QR code': 'Share your QR code',
		Asset: 'Asset',
		Error: 'Error',
		'Use {currency} and save money': 'Use {currency} and save money',
		'Learn more': 'Learn more',
		'Select an asset for payment': 'Select an asset for payment',
		'A minimum of 35 TRX is required for guaranteed withdrawal. The real cost depends on the payment and takes a smaller amount':
			'A minimum of 35 TRX is required for guaranteed withdrawal. The real cost depends on the payment and takes a smaller amount',
		Network: 'Network',
		'Address copied': 'Address copied',
		'Hash copied': 'Hash copied',
		'There are no transactions yet': 'There are no transactions yet',
		'Transaction fee will be calculated automatically': 'Transaction fee will be calculated automatically',
		'In progress': 'In progress',
		'You cannot send funds to the same address': 'You cannot send funds to the same address',
		'Error in calculating withdrawal fees': 'Error in calculating withdrawal fees',
		'Error in preparing withdrawal data': 'Error in preparing withdrawal data',
		'Withdrawal transaction successfully created': 'Withdrawal transaction successfully created',
		'Error confirmating the withdrawal': 'Error confirmating the withdrawal',
		'Salary wallet': 'Salary wallet',
		'Not enough TRX to create transaction': 'Not enough TRX to create transaction',
		'Enter your Pin-code': 'Enter your Pin-code',
		'Pin-code is incorrect. Try again': 'Pin-code is incorrect. Try again',
		'Create PIN-code': 'Create PIN-code',
		'Confirm PIN-code': 'Confirm PIN-code',
		'Pin-code will be used to confirm transactions.': 'Pin-code will be used to confirm transactions.',
		"Pin-code doesn't match. Try again": "Pin-code doesn't match. Try again",
		"Error! You're trying to login to Mobile account from wrong Telegram":
			"Error! You're trying to login to Mobile account from wrong Telegram",
		'The previous transaction is being processed. Please wait for confirmation before creating the next one.':
			'The previous transaction is being processed. Please wait for confirmation before creating the next one.',
		'Top up': 'Top up',
		'Top up2': 'Top up',
		'Fee payment': 'Fee payment',
		'Show more': 'Show more',
		'How to use {currency}': 'How to use {currency}',
		'{currency} are internal units for use only within {productName}. They cannot be withdrawn or converted. Value: 1 {currency} = 1 USD.':
			'{currency} are internal units for use only within {productName}. They cannot be withdrawn or converted. Value: 1 {currency} = 1 USD.',
		'Pay fees': 'Pay fees',
		'TRON fees can be paid using {currency}, simplifying fee management for outgoing transactions.':
			'TRON fees can be paid using {currency}, simplifying fee management for outgoing transactions.',
		'Read more': 'Read more',
		'My address': 'My address',
		'No transactions yet': 'No transactions yet',
		"You don't have any assets available to receive yet.": "You don't have any assets available to receive yet.",
		'Cover fees for outgoing transactions and save up to 50%.':
			'Cover fees for outgoing transactions and save up to 50%.',
		'Cover network fees for outgoing transactions using {currency}.':
			'Cover network fees for outgoing transactions using {currency}.',
		'Pay for AML checks': 'Pay for AML checks',
		'AML checks reveal the origin of funds and protect you from asset blocking or freezing. Run a check now -  peace of mind is priceless!':
			'AML checks reveal the origin of funds and protect you from asset blocking or freezing. Run a check now - peace of mind is priceless!',
		'Coming soon': 'Coming soon',
		"Stay tuned for updates and don't miss new features as they roll out":
			"Stay tuned for updates and don't miss new features as they roll out.",
		'Add address': 'Add address',
		'Give a name': 'Give a name',
		'Enter a title to easily identify this address.': 'Enter a title to easily identify this address.',
		Expence: 'Expence',
		'{billingName} USD Mobile Balance': '{billingName} USD Mobile Balance',
		'{billingName} Mobile balance is needed to pay for Mobile Wallet services...':
			'{billingName} Mobile balance is needed to pay for Mobile Wallet services...',
		'More about services': 'More about services',
		'Your balance': 'Your balance',
		'Buy {currency}': 'Buy {currency}',
		'About {currency}': 'About {currency}',
		'What is {currency} for': 'What is {currency} for',
		'{currency} usage options': '{currency} usage options',
		'Commission payment': 'Commission payment',
		"You can pay outgoing transaction fees with up to 50% discount using BH USD.\nTry it — it's easy!":
			"You can pay outgoing transaction fees with up to 50% discount using BH USD.\nTry it — it's easy!",
		'AML check payment': 'AML check payment',

		'AML check': 'AML check',
		'Address for AML check': 'Address for AML check',
		'Auto-detected. Select manually if needed.': 'Auto-detected. Select manually if needed.',
		'The network could not be detected automatically.\nPlease select the network manually.':
			'The network could not be detected automatically.\nPlease select the network manually.',
		Reset: 'Reset',
		'Insufficient balance for this payment methods.': 'Insufficient balance for this payment methods.',
		'Price per check': 'Price per check',
		'AML check V2': 'AML check',
		'Scan address': 'Scan address',

		'Risk level': 'Risk level',

		'Low risk': 'Low risk',
		'Medium risk': 'Medium risk',
		'High risk': 'High risk',
		'Outdated risk': 'Outdated risk',
		'Unchecked risk': 'Unchecked risk',
		'Check AML risk': 'Check AML risk',
		'In progress V2': 'In progress',
		'AML Details': 'AML Details',
		'Source of funds': 'Source of funds',
		'Use of funds': 'Use of funds',
		Category: 'Category',
		'Share V2': 'Share',
		'Recheck address': 'Recheck address',
		Counterparties: 'Counterparties',
		Transactions: 'Transactions',
		'All balance': 'All balance',
		'Last check': 'Last check',
		'Part of the funds associated with high-risk sources.': 'Part of the funds associated with high-risk sources.',
		'All connections': 'All connections',
		'Source of funds Avg. risk (%)': 'Source of funds\nAvg. risk (%)',
		'Use of funds Avg. risk (%)': 'Use of funds\nAvg. risk (%)',
		'How funds are categorized by risk level based on their origin and the destinations they were sent to.':
			'How funds are categorized by risk level based on their origin and the destinations they were sent to.',
		'AML checks provide risk assessment information required for compliance procedures. \nInitiate an AML check to obtain risk assessment information.':
			'AML checks provide risk assessment information required for compliance procedures. \nInitiate an AML check to obtain risk assessment information.',
		Low: 'Low',
		Medium: 'Medium',
		High: 'High',
		Settled: 'Settled',
		Uncategorized: 'Uncategorized',
		'AML verifies the source of funds and helps avoid blocking or freezing assets.\nDo it now — peace of mind is worth it!':
			'AML verifies the source of funds and helps avoid blocking or freezing assets.\nDo it now — peace of mind is worth it!',

		'To be announced': 'To be announced',
		'Not enough balance': 'Not enough balance',
		'Fee amount_v3': 'Fee amount',
		Balance: 'Balance',
		'Choose fee payment method': 'Choose fee payment method',
		'Choose fee payment method. The cost varies depending on the option chosen.':
			'Choose fee payment method. The cost varies depending on the option chosen.',
		'Password and Pin-code have been created': 'Password and Pin-code have been created',
		'Fee payment method': 'Fee payment method',
		'Amount to pay': 'Amount to pay',
		'Select payment address': 'Select payment address',
		Period: 'Period',
		'Last week': 'Last week',
		'Last month': 'Last month',
		'Last year': 'Last year',
		'Insufficient balance to pay the commission': 'Insufficient balance to pay the commission',
		'Loading error!': 'Loading error!',
		Custom: 'Custom',
		'Select period': 'Select period',
		'Start date': 'Start date',
		'end date': 'end date',
		'Enter your login and password to verify your identity': 'Enter your login and password to verify your identity',
		'PIN-code recovery': 'PIN-code recovery',
		'Forgot password?': 'Forgot password?',
		'Create a PIN code that will be used to log in and confirm transactions.':
			'Create a PIN code that will be used to log in and confirm transactions.',
		'PIN-code has been restored': 'PIN-code has been restored',
		'All transactions': 'All transactions',
		'All wallets': 'All wallets',
		'No assets yet': 'No assets yet',
		"They'll appear here soon": "They'll appear here soon",

		'High-risk % shows the portion of funds associated with high-risk sources.':
			'High-risk % shows the portion of funds associated with high-risk sources.',
		'This percentage reflects the combined contribution of funds linked to sources classified as high risk, such as sanctions, scams, stolen funds, terrorism financing, and other suspicious activities.\nA higher value does not represent the overall AML risk level of the address. It indicates that part of the funds originates from high-risk sources and may require additional attention during compliance checks.':
			'This percentage reflects the combined contribution of funds linked to sources classified as high risk, such as sanctions, scams, stolen funds, terrorism financing, and other suspicious activities.\nA higher value does not represent the overall AML risk level of the address. It indicates that part of the funds originates from high-risk sources and may require additional attention during compliance checks.',
		'Review the AML details to understand the source and use of funds.\nUse this information to make an informed decision before interacting with these assets.':
			'Review the AML details to understand the source and use of funds.\nUse this information to make an informed decision before interacting with these assets.',

		'This AML result may no longer reflect the current state of the address.\nWe recommend running a new AML check to get up-to-date information.':
			'This AML result may no longer reflect the current state of the address.\nWe recommend running a new AML check to get up-to-date information.',

		'Why this address has no AML result yet': 'Why this address has no AML result yet',
		'This address has not been checked for AML risks yet.': 'This address has not been checked for AML risks yet.',
		'There is not enough data to assess the risk level of this address at the moment.\nAn unchecked status does not indicate low or high risk — it means the risk has not been evaluated.':
			'There is not enough data to assess the risk level of this address at the moment.\nAn unchecked status does not indicate low or high risk — it means the risk has not been evaluated.',
		'Run an AML check to check the address, calculate its risk score, and view detailed information about the source and use of funds.':
			'Run an AML check to check the address, calculate its risk score, and view detailed information about the source and use of funds.',

		'AML Risk': 'AML Risk',
		'How AML risk is calculated': 'How AML risk is calculated',

		'AML check is in progress.': 'AML check is in progress.',
		'This may take some time. You can continue using the wallet as usual.\nYou will be notified once the check is complete.':
			'This may take some time. You can continue using the wallet as usual.\nYou will be notified once the check is complete.',

		'This address has not been AML-checked yet.\nPlease run an AML check before sending funds.':
			'This address has not been AML-checked yet.\nPlease run an AML check before sending funds.',
		'Check address now': 'Check address now',
		'Estimated time': 'Estimated time',

		Add: 'Add',
		'Add to Home Screen': 'Add to Home Screen',
		'Add {productName} to Home Screen': 'Add {productName} to Home Screen',
		'Tap the {icon} button at the bottom': 'Tap the {icon} button at the bottom',
		'Select {icon} <p>to Home Screen</p>': 'Select {icon} <p>to Home Screen</p>',

		'Password recovery': 'Password recovery',
		'The only way to recover your wallet is to complete the recovery procedure through Support':
			'The only way to recover your wallet is to complete the recovery procedure through Support',
		'Send a request and follow the instructions provided in {supportBotName}':
			'Send a request and follow the instructions provided in {supportBotName}',
		'Send a request': 'Send a request',
		More: 'More',
		'Send only {coinName} to this address. Sending any other assets may result in permanent loss.':
			'Send only {coinName} to this address. Sending any other assets may result in permanent loss.',
		Today_uppercase: 'TODAY',
		Yesterday_uppercase: 'YESTERDAY',
		'Please note: Once the PIN-code is changed, withdrawal will be disabled for {time}.':
			'Please note: Once the PIN-code is changed, withdrawal will be disabled for {time}.',
		Mo: 'Mo',
		Tu: 'Tu',
		We: 'We',
		Th: 'Th',
		Fr: 'Fr',
		Sa: 'Sa',
		Su: 'Su',
		Apply: 'Apply',
		'{currency} needs to be topped up': '{currency} needs to be topped up',
		'Copy error code': 'Copy error code',
		'Pick a username that hasn’t been taken yet or enter your invite. You can use letters, numbers, dots, and underscores.':
			'Pick a username that hasn’t been taken yet or enter your invite. You can use letters, numbers, dots, and underscores.',
		'Enter username or invite name': 'Enter username or invite name',
		'Terms of Use': 'Terms of Use',
		'I understand that I can only access this wallet using the account I registered with.':
			'I understand that I can only access this wallet using the account I registered with.',
		'Create password': 'Create password',
		'Create a password for account recovery. IMPORTANT: keep this password safe, and DO NOT lose it':
			'Create a password for account recovery. IMPORTANT: keep this password safe, and DO NOT lose it',
		'The password must contain from {fromNumber} - {toNumber} characters, including lowercase and uppercase Latin letters and at least one number':
			'The password must contain from {fromNumber} - {toNumber} characters, including lowercase and uppercase Latin letters and at least one number',
		'Password must contain at least {number} characters': 'Password must contain at least {number} characters',
		'Enter your username and PIN-code': 'Enter your username and PIN-code',
		'Forgot PIN-code?': 'Forgot PIN-code?',
		'Welcome back, {username}': 'Welcome back, {username}',
		Swap: 'Swap',
		Buy: 'Buy',

		'Recent transactions': 'Recent transactions',
		'View all': 'View all',
		'Swap is currently unavailable, but we are working on getting it up and running':
			'Swap is currently unavailable, but we are working on getting it up and running',
		'Buy is currently unavailable, but we are working on getting it up and running.':
			'Buy is currently unavailable, but we are working on getting it up and running.',
		"You don't have any assets to send. Please top up your balance.":
			"You don't have any assets to send. Please top up your balance.",
		'Empty page': 'Empty page',
		'There is nothing on this page': 'There is nothing on this page',
		'Username must contain at least {number} characters': 'Username must contain at least {number} characters',
		'Enter PIN-code': 'Enter PIN-code',
		'You PIN-code is required to authenticate secure actions':
			'You PIN-code is required to authenticate secure actions',
		'Select asset to send': 'Select asset to send',
		'Select asset to receive': 'Select asset to receive',
		"You don't have transactions": "You don't have transactions",
		'No addresses yet': 'No addresses yet',
		'Enter address': 'Enter address',
		To: 'To',
		Next: 'Next',
		'Please wait': 'Please wait',
		'The address incorrect': 'The address incorrect',
		'You’ve already sent USDT. A new transfer will be available once the current transaction is completed.':
			'You’ve already sent USDT. A new transfer will be available once the current transaction is completed.',
		Done: 'Done',
		Max: 'Max',
		'Network fee': 'Network fee',
		'Best price': 'Best price',
		'Benefit up to': 'Benefit up to',
		'Confirm transaction': 'Confirm transaction',
		'Amount to send': 'Amount to send',
		'Network fee_v2': 'Network fee',
		From: 'From',
		Available_v2: 'Available',
		'Insufficient balance for this method.': 'Insufficient balance for this method.',
		'Attention: The transaction is already in progress from this address.':
			'Attention: The transaction is already in progress from this address.',
		Successful: 'Successful',
		'The transaction has been sent.': 'The transaction has been sent.',
		'Your payment is being processed.': 'Your payment is being processed.',
		'Processing may take some time and involve multiple technical transactions, all of which will be recorded in the transaction history.':
			'Processing may take some time and involve multiple technical transactions, all of which will be recorded in the transaction history.',
		'Only "A-Z", "a-z", "0-9", "_", "." or "-" allowed': 'Only "A-Z", "a-z", "0-9", "_", "." or "-" allowed',
		Attention: 'Attention',
		'Enter amount': 'Enter amount',
		'Select asset to pay': 'Select asset to pay',
		'Select address to pay': 'Select address to pay',
		'Password is not valid': 'Password is not valid',
		'Enter the characters you see': 'Enter the characters you see',
		'Can’t read?': 'Can’t read?',
		'Enter the CAPTCHA code': 'Enter the CAPTCHA code',
		Submit: 'Submit',
		'Invalid code.': 'Invalid code.',
		'Please try again.': 'Please try again.',
		'Creating wallet addresses…': 'Creating wallet addresses…',
		'Not enough funds to cover the fee': 'Not enough funds to cover the fee',
		'Not enough {currency} funds to cover the fee': 'Not enough {currency} funds to cover the fee',
		'With this fee, confirmation may take longer than usual.':
			'With this fee, confirmation may take longer than usual.',
		'Transaction cannot be confirmed with this fee.': 'Transaction cannot be confirmed with this fee.',
		'Verification required': 'Verification required',
		'This wallet is already active on another device. To continue using it here, please verify your identity':
			'This wallet is already active on another device. To continue using it here, please verify your identity',
		'Verify identity': 'Verify identity',
		'Verification successful': 'Verification successful',
		'Welcome back!': 'Welcome back!',
		'Confirm login': 'Confirm login',
		'Enter your password to continue': 'Enter your password to continue',
		'The bot wasn’t created': 'The bot wasn’t created',
		Devices: 'Devices',
		'Use your account on multiple devices': 'Use your account on multiple devices',
		'This device': 'This device',
		Online: 'Online',
		'Terminate all other sessions': 'Terminate all other sessions',
		'Logs out all devices except for this one.': 'Logs out all devices except for this one.',
		'Active sessions': 'Active sessions',
		'Enter PIN': 'Enter PIN',
		'PIN is required to confirm this action': 'PIN is required to confirm this action',
		Language: 'Language',
		'Interface language': 'Interface language',
		'Estimated blockchain fee maximum. You are only charged the actual network fee at the moment of confirmation.':
			'Estimated blockchain fee maximum. You are only charged the actual network fee at the moment of confirmation.',
		'AML risk indicates the potential exposure of funds to illicit or high-risk activity.':
			'AML risk indicates the potential exposure of funds to illicit or high-risk activity.',
		'What does this mean?': 'What does this mean?',
		'The risk level is calculated based on transaction history and connections to various sources and counterparties.':
			'The risk level is calculated based on transaction history and connections to various sources and counterparties.',

		'It helps identify whether funds may be associated with sanctions, fraud, illegal services, or other risky activity.':
			'It helps identify whether funds may be associated with sanctions, fraud, illegal services, or other risky activity.',
		'What should you do?': 'What should you do?',
		'Use AML risk as a reference when interacting with addresses.':
			'Use AML risk as a reference when interacting with addresses.',
		'Review detailed AML information to better understand the nature and origin of funds.':
			'Review detailed AML information to better understand the nature and origin of funds.',
		'No AML checks yet. Run an AML check to review potential risks for this address.':
			'No AML checks yet. Run an AML check to review potential risks for this address.',
		'Learn more v2': 'Learn more',
		'Recent AML checks': 'Recent AML checks',
		'View all v2': 'View all',
		'Payment purpose': 'Payment purpose',
		'Attached files': 'Attached files',
		'Files attached to this payment': 'Files attached to this payment',
		'Access restricted': 'Access restricted',
		'Your current location is included in the list of restricted countries configured by the Administrator (root).':
			'Your current location is included in the list of restricted countries configured by the Administrator (root).',
		'Upload files': 'Upload files',
		'Maximum file size: 10 MB': 'Maximum file size: 10 MB',
		'Attach supporting files for this payment': 'Attach supporting files for this payment',
		'Attach files': 'Attach files',
		Type: 'Type',
		'More details': 'More details',
		'Something went wrong while checking the address. Please try again or come back later.':
			'Something went wrong while checking the address. Please try again or come back later.',
		'AML check history': 'AML check history',
		m: 'm',
		s: 's',
		'Address already checked': 'Address already checked',
		'The AML check request was canceled because this address already has a valid and up-to-date AML result.':
			'The AML check request was canceled because this address already has a valid and up-to-date AML result.',
		'To proceed, you must provide a payment purpose or attach a supporting file.':
			'To proceed, you must provide a payment purpose or attach a supporting file.',
		Unverified: 'Unverified',
		'This address hasnt appeared in any known AML records — flagged or otherwise.':
			"This address hasn't appeared in any known AML records — flagged or otherwise.",
		'No risk data available — this address has no recorded activity.':
			'No risk data available — this address has no recorded activity.',
		'The address does not match the selected network': 'The address does not match the selected network',
		'Choose the correct blockchain.': 'Choose the correct blockchain.'
	},
};

export default en;
